import { Component, OnInit } from '@angular/core';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';

@Component({
  selector: 'app-helping-total-page',
  templateUrl: './helping-total-page.component.html',
  styleUrls: ['./helping-total-page.component.scss'],
})
export class HelpingTotalPageComponent implements OnInit {
  hot: any[] = [];
  all: any[] = [];

  constructor(private api: MarketingApiService) {}

  ngOnInit(): void {
    this.findArticleCategories();
    this.findArticleTags();
  }

  gotoArticle(data: any) {
    window.location.href =
      `/helping/detail/` + data.tag_id + `/p/` + 1 + `/article/` + data.id;
  }

  loadingTag = false;
  tags: any[] = [];
  async findArticleTags() {
    try {
      this.loadingTag = true;
      const r = await this.api.findArticleTags();
      this.tags = r.data;
    } catch (error) {
    } finally {
      this.loadingTag = false;
    }
  }

  categories: any[] = [];
  async findArticleCategories() {
    try {
      this.loadingTag = true;
      const r = await this.api.findArticleCategories();
      this.categories = r.data;
    } catch (error) {
    } finally {
      this.loadingTag = false;
    }
  }

  formatId(name: string) {
    return name
      .toLowerCase()
      .replace(/\s+/g, '-') // 空格 → -
      .replace(/&/g, 'and') // & → and
      .replace(/[^a-z0-9\u4e00-\u9fa5-]/g, ''); // 去掉非法字符
  }
}
